<template>
	<div class="forums">
		<template v-if="isPc">
			<img class="forums-title" v-if="En" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/title-home-forums-en.png" alt="">
			<img class="forums-title" v-else src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/title-home-forums.png" alt="">
		</template>
		<template v-else>
			<img class="forums-title" v-if="En" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/wap/title-home-forums-en.png" alt="">
			<img class="forums-title" v-else src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/wap/title-home-forums.png" alt="">
		</template>
		<div class="forums1">
			{{ $t('newbanner9') }}
		</div>
		<div class="forums2">
			<div class="swiper mySwiper1">
				<div class="swiper-wrapper">
					<div class="swiper-slide" v-for="v in list" :key="v.uuid" @click="openDetail(v)">
						<div class="bg"></div>
						<div class="date">{{ v.activityDate }}</div>
						<div class="time">{{ v.activityStartTime }}-{{ v.activityEndTime }}</div>
						<div class="title">{{ v['name' + En] }}</div>
						<img :src="(v['topCoverUrl' + En] || v['topCoverUrl']) + '?x-image-process=image/resize,w_1200,limit_0'" />
					</div>
				</div>
			</div>
		</div>
		<div class="forums3">
			<div class="line">
				<div class="btns">
					<div class="btn" :class="activeIndex == 0 ? 'disabled' : ''" @click="prevFn">
						<img style="transform: rotate(180deg);" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/right-black.png" alt="">
					</div>
					<div class="btn" :class="activeIndex == (list.length - 3) ? 'disabled' : ''" @click="nextFn">
						<img src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/right-black.png" alt="">
					</div>
				</div>
			</div>
		</div>
		<div class="forums4">
			<div class="btns">
				<el-tooltip popper-class="expect-tooltips" effect="dark" :content="En ? 'Coming Soon' : '敬请期待'" placement="top">
					<div class="btn">
						{{ $t('newbanner6') }}
						<img class="img1" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/right-black.png" alt="">
						<img class="img2" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/right-white.png" alt="">
					</div>
				</el-tooltip>
				<!-- <div class="btn" @click.stop="moreFn">
					{{ $t('newbanner6') }}
					<img class="img1" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/right-black.png" alt="">
					<img class="img2" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/right-white.png" alt="">
				</div> -->
			</div>
		</div>
	</div>
</template>

<script>
import protal from "@/api/protal";
export default {
	name: 'news_events',
	data() {
		return {
			swiper: null,
			list: [],
			activeIndex: ''
		}
	},
	created() {
		this.queryWebActivityList()
	},
	methods: {
		// 打开详情页
		openDetail(v) {
			this.$jsAPI('track', 'ciif_homePage_activity', {
				contentID_var: v.uuid,
				contentName_var: v.name
			})
			this.$store.commit('setPageName', {
				name:'活动详情',
				nameEn:'Event details',
			})
			this.openMatch({ path: '/match_process', query: { pageType: 'events', uuid: v.uuid } },v)
		},
		// 查询首页置顶新闻列表
		queryWebActivityList() {
			protal.queryWebActivityList({
				"pageNum": 1,
				"pageSize": 10,
				"topSts": 0
			}).then(r => {
				this.list = r.data
				this.setSwiper()
			})
		},
		setSwiper() {
			const that = this
			this.$nextTick(() => {
				this.swiper = new Swiper('.mySwiper1', {
					slidesPerView: this.isPc ? 3 : 2,
					spaceBetween: this.isPc ? 22 : 11,
					onTransitionEnd: function (swiper) {
						that.activeIndex = swiper.activeIndex
					},
				})
			})
		},
		prevFn() {
			this.swiper.slidePrev()
		},
		nextFn() {
			this.swiper.slideNext()
		},
		moreFn() {
			this.$jsAPI('track', 'ciif_homePage_moreActivity')
			location.href = 'https://www.ciif-expo.cn/ciifVisitor/forumList/index'
		},
	}
}
</script>

<style lang="less" scoped>
@media screen and (min-width: 769px) {
	.forums {
		background-image: url(https://obs-gociif.ciif-expo.com/ciif/static/images/new/chilun3.png);
		background-size: 182px auto;
		background-repeat: no-repeat;
		background-position: 1661px 45px;

		.forums-title {
			width: auto;
			height: 144px;
			margin: 120px 0 0;
		}

		.forums1 {
			padding-left: 140px;
			font-family: Inter, syn;
			font-weight: 400;
			font-size: 24px;
			color: #666666;
			line-height: 32px;
			text-align: left;
			font-style: normal;
			margin-top: -20px;
			margin-bottom: 40px;
		}

		.forums2 {
			width: 1664px;
			padding: 0 12px;
			margin: 0 auto;
			overflow: hidden;

			.swiper-wrapper {
				padding: 20px 0;
			}

			.swiper-slide {
				position: relative;
				padding-top: 22px;
				cursor: pointer;

				&::before {
					content: "";
					position: absolute;
					left: 0;
					top: 0;
					width: 1px;
					height: 400px;
					background: #999999;
					z-index: 1;
				}

				&::after {
					content: "";
					position: absolute;
					left: 0;
					top: 0;
					width: 2px;
					height: 100px;
					background: #F4501C;
					z-index: 1;
				}

				.date {
					font-family: Inter, syn;
					font-weight: 500;
					font-size: 20px;
					color: #666666;
					line-height: 20px;
					text-align: left;
					font-style: normal;
					padding-left: 28px;
					margin-bottom: 13px;
					position: relative;
					z-index: 1;
				}

				.time {
					font-family: Inter, syn;
					font-weight: 600;
					font-size: 36px;
					color: #F4501C;
					line-height: 36px;
					text-align: left;
					font-style: normal;
					margin-bottom: 31px;
					padding-left: 28px;
					position: relative;
					z-index: 1;
				}

				.title {
					font-family: MiSans, MiSans;
					font-weight: 500;
					font-size: 24px;
					color: #000000;
					line-height: 36px;
					height: 72px;
					text-align: left;
					font-style: normal;
					margin-bottom: 46px;
					padding-left: 28px;
					position: relative;
					z-index: 1;
				}

				img {
					width: 528px;
					height: 297px;
					border-radius: 24px;
					position: relative;
					z-index: 1;
				}

				&:hover {
					
					.bg {
						position: absolute;
						left: -12px;
						top: -16px;
						bottom: -8px;
						right: -12px;
						background-color: #F4501C;
						border-radius: 24px;
					}

					.date, .time, .title {
						color: #fff;
					}

					&::after {
						background-color: #fff;
					}

					&::before {
						background-color: rgba(255, 255, 255, 0.2);
					}
				}
			}
		}

		.forums3 {
			width: 1640px;
			position: relative;
			margin: 66px auto 53px;
			
			.line {
				width: 1480px;
				height: 1px;
				background: rgba(11, 36, 63, 0.2);
				position: relative;
			}

			.btns {
				position: absolute;
				left: 100%;
				top: 50%;
				transform: translateY(-50%);
				display: flex;

				.btn {
					width: 68px;
					height: 68px;
					border: 1px solid rgba(22,39,69,0.3);
					border-radius: 50%;
					margin-left: 12px;
					display: flex;
					align-items: center;
					justify-content: center;
					cursor: pointer;

					img {
						width: 24px;
						height: auto;
					}

					&.disabled {
						opacity: 0.5;
						cursor: not-allowed;
					}
				}
			}
		}

		.forums4 {
			width: 1640px;
			position: relative;
			margin: 0 auto;
			padding-bottom: 208px;

			.btns {
				display: flex;

				.btn {
					height: 56px;
					border: 1px solid rgba(11, 36, 63, 0.6);
					border-radius: 12px;
					font-family: MiSans, MiSans;
					font-weight: 500;
					font-size: 16px;
					color: #0B243F;
					line-height: 16px;
					text-align: left;
					font-style: normal;
					padding: 0 28px 0 20px;
					display: flex;
					align-items: center;
					justify-content: center;
					margin-right: 16px;
					cursor: pointer;

					img {
						width: 24px;
						height: auto;
						margin-left: 12px;
						display: none;

						&.img1 {
							display: block;
						}

						&.img2 {
							display: none;
						}
					}

					&:hover {
						background-color: #F4501C;
						border-color: #F4501C;
						color: #fff;

						img {

							&.img1 {
								display: none;
							}

							&.img2 {
								display: block;
							}
						}
					}
				}
			}
		}
	}
}

@media screen and (max-width: 768px) {
	.forums {
		background-image: url(https://obs-gociif.ciif-expo.com/ciif/static/images/new/chilun.png);
		background-size: 1.44rem auto;
		background-repeat: no-repeat;
		background-position: 6.4rem 0.1rem;
		background-color: #F4F4F6;
		padding-top: 1.2rem;

		.forums-title {
			width: 100%;
			height: auto;
		}

		.forums1 {
			padding: 0 .36rem;
			font-family: Inter, syn;
			font-weight: 400;
			font-size: .26rem;
			color: #666666;
			line-height: .4rem;
			text-align: left;
			font-style: normal;
			margin-top: -0.1rem;
			margin-bottom: .6rem;
		}

		.forums2 {
			width: 6.78rem;
			margin: 0 auto;
			overflow: hidden;

			.swiper-wrapper {
			}

			.swiper-slide {
				position: relative;
				padding-top: .16rem;
				cursor: pointer;

				&::before {
					content: "";
					position: absolute;
					left: 0;
					top: 0;
					bottom: 1rem;
					width: 1px;
					background: #999999;
					z-index: 1;
				}

				&::after {
					content: "";
					position: absolute;
					left: 0;
					top: 0;
					width: 2px;
					height: 1.08rem;
					background: #F4501C;
					z-index: 1;
				}

				.date {
					font-family: Inter, syn;
					font-weight: 500;
					font-size: .24rem;
					color: #666666;
					line-height: .24rem;
					text-align: left;
					font-style: normal;
					padding-left: .26rem;
					margin-bottom: .12rem;
					position: relative;
					z-index: 1;
				}

				.time {
					font-family: Inter, syn;
					font-weight: 600;
					font-size: .4rem;
					color: #F4501C;
					line-height: .4rem;
					text-align: left;
					font-style: normal;
					margin-bottom: .36rem;
					padding-left: .26rem;
					position: relative;
					z-index: 1;
				}

				.title {
					font-family: MiSans, MiSans;
					font-weight: 500;
					font-size: .26rem;
					color: #000000;
					line-height: .36rem;
					height: 1.44rem;
					text-align: left;
					font-style: normal;
					margin-bottom: .4rem;
					padding-left: .26rem;
					position: relative;
					z-index: 1;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 4;
					overflow: hidden;
				}

				img {
					width: 3.28rem;
					height: 1.84rem;
					border-radius: .28rem;
					position: relative;
					z-index: 1;
				}
			}
		}

		.forums3 {
			width: 6.78rem;
			position: relative;
			margin: .85rem auto .55rem;
			
			.line {
				width: 4.74rem;
				height: 1px;
				background: rgba(11, 36, 63, 0.2);
				position: relative;
			}

			.btns {
				position: absolute;
				left: 100%;
				top: 50%;
				transform: translateY(-50%);
				display: flex;

				.btn {
					width: .88rem;
					height: .88rem;
					border: 1px solid rgba(22,39,69,0.3);
					border-radius: 50%;
					margin-left: .16rem;
					display: flex;
					align-items: center;
					justify-content: center;
					cursor: pointer;

					img {
						width: .32rem;
						height: auto;
					}

					&.disabled {
						opacity: 0.5;
						cursor: not-allowed;
					}
				}
			}
		}

		.forums4 {
			width: 6.78rem;
			position: relative;
			margin: 0 auto;
			padding-bottom: 1.6rem;

			.btns {
				display: flex;

				.btn {
					height: .88rem;
					border: 1px solid rgba(11, 36, 63, 0.6);
					border-radius: .2rem;
					font-family: MiSans, MiSans;
					font-weight: 500;
					font-size: .24rem;
					color: #0B243F;
					line-height: .24rem;
					text-align: left;
					font-style: normal;
					padding: 0 .28rem;
					display: flex;
					align-items: center;
					justify-content: center;
					cursor: pointer;

					img {
						width: .36rem;
						height: auto;
						margin-left: .12rem;
						display: none;

						&.img1 {
							display: block;
						}

						&.img2 {
							display: none;
						}
					}

					&:hover {
						background-color: #F4501C;
						border-color: #F4501C;
						color: #fff;

						img {

							&.img1 {
								display: none;
							}

							&.img2 {
								display: block;
							}
						}
					}
				}
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/pages/home/components/forums.vue